import { string, object, boolean, number } from 'yup';
import { AIVoice, StatementColumns, StatementLogoPosition } from '../../models';
const EMAIL_ERROR_POSTFIX = `must be a valid email address`;
const addressSchema = object({
    lineOne: string().nullable().optional(),
    lineTwo: string().nullable().optional(),
    city: string().nullable().optional(),
    state: string().nullable().optional(),
    country: string().nullable().optional(),
    postalCode: string().nullable().optional(),
});
const statementColumnsSchema = object({
    [StatementColumns.Activity]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.Amount]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.Balance]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.Date]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.DueDate]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.OverdueAge]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.Payments]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
    [StatementColumns.Reference]: string().oneOf([`show`, `hide`, `truncate`]).required().nonNullable(),
});
export const settingUpdateSchema = object({
    logoUrl: string().url().nullable().optional(),
    active: boolean().optional(),
    webhookEnabled: boolean().optional(),
    webhookUrl: string().url().nullable().optional(),
    bccAddress: string().email(`BCC Address ${EMAIL_ERROR_POSTFIX}`).nullable().optional(),
    ccAddress: string().email(`CC Address ${EMAIL_ERROR_POSTFIX}`).nullable().optional(),
    replyToAddress: string().email(`Reply To Address ${EMAIL_ERROR_POSTFIX}`).nullable().optional(),
    fromAddress: string().matches(/^(?!.*\.$)(?!^\.)[a-zA-Z0-9_.-]+$/, {
        message: `From Username must only include letters, numbers, hyphens, dots and underscores. (Do not include the @)`,
        excludeEmptyString: true,
    }).trim().nullable().optional(),
    customDomain: string().matches(/^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/, {
        excludeEmptyString: true,
        message: `Domain must only include domain name and TLD (e.g. example.com). (Do not include https://)`,
    }).trim().nullable().optional(),
    companyNumber: string().nullable().optional(),
    companyNumberType: string().nullable().optional(),
    taxNumber: string().nullable().optional(),
    companyContactNumber: string().nullable().optional(),
    companyEmail: string().email(`Company Email ${EMAIL_ERROR_POSTFIX}`).nullable().optional(),
    companyAddress: addressSchema.nullable().optional(),
    statementFooter: string().nullable().optional(),
    timezone: string().required(`A timezone is required`),
    autofreezeInvoice: boolean().required(`Autofreeze Invoice Setting is required`),
    setSendFlagLateFee: boolean().required(`Set Send Flag Late Fee Setting is required`),
    onlySendPrimaryContact: boolean().nullable().optional(),
    portalViewAllInvoices: boolean().required(`Portal View All Invoices Setting is required`),
    statementLogoPosition: string().oneOf(Object.values(StatementLogoPosition)).required(`Statement Logo Position Setting is required`),
    useDisplayName: boolean().required(`Use Display Name Setting is required`),
    fromName: string().required('From Name Setting is required'),
    includeCreditNotes: boolean().required(`Include Credit Notes Setting is required`),
    disableStatementLinks: boolean().nullable().optional(),
    statementAlwaysLegalName: boolean().required(`Statement Always Legal Name Setting is required`),
    useExpectedPaymentDate: boolean().nullable().optional(),
    primaryColor: string().min(7).max(7).nullable().optional(),
    signatureHtml: string().nullable().optional(),
    signatureJson: string().nullable().optional(),
    aiVoice: string().oneOf(Object.values(AIVoice)),
    aiMaxCallDuration: number().min(1, `AI Max Call Duration must be greater than 0`).max(5, `AI Max Call Duration must be less than 6`),
    syncNotesOnAction: boolean().required(`Sync notes on action is required`),
    statementColumnSettings: statementColumnsSchema.required(`Statement Column Settings Not Found`).nonNullable(),
    agedAnalysisBreakpointOne: number()
        .min(1, `Aged Analysis Breakpoint One must be greater than 0`)
        .max(365, `Aged Analysis Breakpoint One must be less than 366`),
    agedAnalysisBreakpointTwo: number()
        .min(1, `Aged Analysis Breakpoint Two must be greater than 0`)
        .max(365, `Aged Analysis Breakpoint Two must be less than 366`)
        .nullable().optional(),
    agedAnalysisBreakpointThree: number()
        .min(1, `Aged Analysis Breakpoint Three must be greater than 0`)
        .max(365, `Aged Analysis Breakpoint Three must be less than 366`)
        .nullable().optional(),
})
    .test('cc-bcc-different', 'BCC and CC addresses cannot be the same', v => {
    return (!!v.bccAddress && !!v.ccAddress && v.bccAddress !== v.ccAddress) || !v.bccAddress || !v.ccAddress;
});
//# sourceMappingURL=settings.js.map